module.exports = __webpack_public_path__ + "static/media/Opened.16d32c23.svg";